import React, { Component } from 'react';
import './MigrationForm.css'
import {
  Row,
  Col,
  Button
} from 'reactstrap';
import Stepper from 'react-stepper-horizontal'
import MigrationDatabaseForm from './database/MigrationDatabaseForm';
import MigrationCredentialsForm from './credentials/MigrationCredentialsForm';
import MigrationAstreaForm from './astrea/MigrationAstreaForm';

class MigrationForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            steps: [{title: 'Banco de dados'}, {title: 'Credenciais'}, {title: 'Astrea'}],
            activeStep: 0
        }
    }

    handleChange = (field, value) => {
        this.props.updateProp(field, value)
    }

    nextStep = () => {
        if(this.state.activeStep === this.state.steps.length - 1)
            return
        this.setState({
            ...this.state,
            activeStep: this.state.activeStep + 1
        })
    }

    previousStep = () => {
        if(this.state.activeStep === 0)
            return
        this.setState({
            ...this.state,
            activeStep: this.state.activeStep - 1
        })
    }

    getComponentByStep = () => {
        switch(this.state.activeStep){
            case 0:
                return <MigrationDatabaseForm handleChange={this.handleChange} entity={this.props.entity} databases={this.props.databases}/>
            case 1:
                return <MigrationCredentialsForm handleChange={this.handleChange} entity={this.props.entity}/>
            case 2:
                return <MigrationAstreaForm handleChange={this.handleChange}  entity={this.props.entity}/>
            default:
                return <div />
        }
    }

    render = () => {
        return (
          <div className="animated fadeIn">
            <div className="step-container">
                {this.getComponentByStep()}
            </div>            
            <Row>
                <Col xs="2">
                    <Button className="step-button" block color="link" type="button" onClick={this.previousStep}><i className="fa fa-chevron-left"></i></Button>
                </Col>
                <Col xs="8">
                    <Stepper steps={this.state.steps} activeStep={this.state.activeStep} />
                </Col>
                <Col xs="2">
                    <Button className="step-button" block color="link" type="button" onClick={this.nextStep}><i className="fa fa-chevron-right"></i></Button>
                </Col>
            </Row>
          </div>
        );
    }
    
}

export default MigrationForm


// WEBPACK FOOTER //
// ./src/views/components/migration-form/MigrationForm.js